import { render, staticRenderFns } from "./PaywallLoggedInText.vue?vue&type=template&id=78a446c8&scoped=true&"
import script from "./PaywallLoggedInText.vue?vue&type=script&lang=js&"
export * from "./PaywallLoggedInText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a446c8",
  null
  
)

export default component.exports